module.exports = __webpack_public_path__ + "img/bankicon3.fef1a436.png";